import { _AbstractSoundInstance } from "./abstractSoundInstance";
/** @internal */
export class _StaticSoundInstance extends _AbstractSoundInstance {
}
//# sourceMappingURL=staticSoundInstance.js.map